
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38.307 9.775c.315.315.565.66.752 1.032.186.372.279.716.279 1.03 0 .345-.09.696-.269 1.054a3.995 3.995 0 01-.762 1.03l-7.82 7.864c-.43.444-.85.77-1.258.978a2.66 2.66 0 01-1.213.311c-.717 0-1.29-.24-1.72-.72-.429-.48-.644-1.12-.644-1.922 0-.53.147-1.304.44-2.32.294-1.018.441-1.755.441-2.214 0-.515-.165-.91-.494-1.181-.33-.272-.795-.408-1.396-.408-.774 0-1.415.186-1.923.558-.509.373-.956.981-1.343 1.826l-1.805 3.782c-.544 1.131-1.153 1.948-1.826 2.449-.673.501-1.49.752-2.45.752H3.159c-1.074 0-1.869-.247-2.385-.741C.258 22.44 0 21.678 0 20.646c0-.243.025-.497.075-.762a7.48 7.48 0 01.226-.87l2.02-6.059a4.429 4.429 0 00.171-1.203c0-.2-.014-.38-.043-.537a2.9 2.9 0 00-.129-.473L.3 4.684a5.74 5.74 0 01-.225-.828A4.324 4.324 0 010 3.051C0 2.034.261 1.27.784.763 1.307.254 2.098 0 3.158 0h12.139c.96 0 1.776.258 2.45.773.672.516 1.281 1.332 1.825 2.45l1.805 3.78c.415.889.87 1.508 1.364 1.86.494.35 1.142.526 1.945.526.587 0 1.042-.14 1.364-.42.322-.279.483-.669.483-1.17 0-.459-.147-1.2-.44-2.224-.294-1.024-.44-1.808-.44-2.352 0-.788.214-1.418.644-1.891.43-.473 1.002-.709 1.719-.709.4 0 .809.107 1.224.322.416.215.831.537 1.246.967l7.82 7.863z","fill":"currentColor","fill-rule":"nonzero"}})])
          )
        }
      }
    